import { getWorkItemTypeIconConfig } from "./issueMappers";

/**
 * Theme-colored work item type icon (Epic / Task / Bug / Story).
 * @param {string} [typeLabel] — display name e.g. "Bug", "Epic"
 * @param {string} [sizeClassName] — Tailwind size for the icon (default ~1rem)
 * @param {string} [className] — extra classes on the SVG
 * @param {boolean} [muted] — neutral secondary color (e.g. unselected type toggle); same glyph as themed.
 */
export default function WorkItemTypeIcon({
  typeLabel,
  sizeClassName = "text-base shrink-0",
  className = "",
  muted = false,
}) {
  const { Icon, colorClass } = getWorkItemTypeIconConfig(typeLabel);
  const colorClasses = muted ? "text-text-secondary" : colorClass;
  return <Icon className={`${sizeClassName} ${colorClasses} ${className}`.trim()} aria-hidden />;
}
